import React from 'react';
interface GlobalBalanceTabProps {
  searchTerm: string;
}
export function GlobalBalanceTab({
  searchTerm
}: GlobalBalanceTabProps) {
  return <div className="bg-gray-50 p-6 rounded-xl shadow-md" data-id="element-219">
      <h2 className="text-3xl font-bold text-gray-800 mb-4 pb-3 border-b-4 border-purple-600" data-id="element-220">
        Dr. Tan's Global Balance System
      </h2>
      <div className="bg-white p-6 rounded-xl shadow-md mb-8" data-id="element-221">
        <h3 className="text-xl font-bold text-teal-700 mb-3" data-id="element-222">
          Three Major Global Balance Patterns
        </h3>
        <p className="text-gray-700 leading-relaxed" data-id="element-223">
          Global Balance treats symptoms by location: <strong data-id="element-224">FRONT</strong>{' '}
          (Yang Ming), <strong data-id="element-225">SIDE</strong> (Shao Yang), and{' '}
          <strong data-id="element-226">BACK</strong> (Tai Yang) of the body. Each pattern uses four
          magical meridians in truss structure formations for static balance and
          dynamic Yin-Yang balancing.
        </p>
      </div>
      <div className="space-y-6" data-id="element-227">
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-228">
          <h3 className="text-2xl font-bold text-teal-700 mb-3" data-id="element-229">
            Yang Ming Global Balance - Front Body Symptoms
          </h3>
          <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-230">
            <strong className="text-blue-800" data-id="element-231">Indications:</strong>
            <span className="text-blue-700" data-id="element-232">
              {' '}
              Chest pain, heartburn, digestion issues, stomach ulcers,
              constipation, nausea, all front body problems
            </span>
          </div>
          <div className="bg-purple-50 p-4 rounded-lg mb-4" data-id="element-233">
            <strong className="text-purple-800" data-id="element-234">Four Magical Meridians:</strong>
            <span className="text-purple-700" data-id="element-235">
              {' '}
              Pericardium + Stomach + Liver + Kidney (Jue Yin - Yang Ming pair)
            </span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-236">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-237">
              <h4 className="font-semibold text-blue-800 mb-3" data-id="element-238">
                PERICARDIUM & STOMACH
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-239">
                {['PC-6 (Col 6)', 'PC-9 (Col 1)', 'PC-3 (Col 5)', 'ST-45', 'ST-36-43', 'ST-44', 'ST-41'].map(point => <span key={point} className="px-3 py-1 bg-blue-200 text-blue-800 rounded-full text-sm font-medium" data-id="element-240">
                    {point}
                  </span>)}
              </div>
            </div>
            <div className="bg-red-50 p-4 rounded-lg" data-id="element-241">
              <h4 className="font-semibold text-red-800 mb-3" data-id="element-242">
                LIVER & KIDNEY
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-243">
                {['LIV-1 to LIV-8', 'KI-1 to KI-10'].map(point => <span key={point} className="px-3 py-1 bg-red-200 text-red-800 rounded-full text-sm font-medium" data-id="element-244">
                    {point}
                  </span>)}
              </div>
            </div>
          </div>
          <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 mt-4" data-id="element-245">
            <strong className="text-yellow-800" data-id="element-246">Dynamic Balancing:</strong>
            <span className="text-yellow-700" data-id="element-247">
              {' '}
              Needle all points on the affected meridian. Use truss structure -
              if pain is on Pericardium, needle Stomach; if on Liver, needle
              Kidney.
            </span>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-248">
          <h3 className="text-2xl font-bold text-teal-700 mb-3" data-id="element-249">
            Shao Yang Global Balance - Side Body Symptoms
          </h3>
          <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-250">
            <strong className="text-blue-800" data-id="element-251">Indications:</strong>
            <span className="text-blue-700" data-id="element-252">
              {' '}
              Rib pain, SI joint dysfunction, temple headache, trapezius pain,
              lateral neck pain, ribcage tension
            </span>
          </div>
          <div className="bg-purple-50 p-4 rounded-lg mb-4" data-id="element-253">
            <strong className="text-purple-800" data-id="element-254">Four Magical Meridians:</strong>
            <span className="text-purple-700" data-id="element-255">
              {' '}
              Heart + Spleen + San Jiao + Gallbladder (Shao Yin - Shao Yang
              pair)
            </span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-256">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-257">
              <h4 className="font-semibold text-blue-800 mb-3" data-id="element-258">
                HEART & SPLEEN
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-259">
                {['HT-3 to HT-9', 'SP-1 to SP-9'].map(point => <span key={point} className="px-3 py-1 bg-blue-200 text-blue-800 rounded-full text-sm font-medium" data-id="element-260">
                    {point}
                  </span>)}
              </div>
            </div>
            <div className="bg-red-50 p-4 rounded-lg" data-id="element-261">
              <h4 className="font-semibold text-red-800 mb-3" data-id="element-262">
                SAN JIAO & GALLBLADDER
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-263">
                {['TH-1 to TH-10', 'GB-34 to GB-44'].map(point => <span key={point} className="px-3 py-1 bg-red-200 text-red-800 rounded-full text-sm font-medium" data-id="element-264">
                    {point}
                  </span>)}
              </div>
            </div>
          </div>
          <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 mt-4" data-id="element-265">
            <strong className="text-yellow-800" data-id="element-266">Lateral Treatment:</strong>
            <span className="text-yellow-700" data-id="element-267">
              {' '}
              Perfect for all lateral/side symptoms. Treat opposite side. Use
              dynamic balance by needling entire affected meridian pathway.
            </span>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-268">
          <h3 className="text-2xl font-bold text-teal-700 mb-3" data-id="element-269">
            Tai Yang Global Balance - Back Body Symptoms
          </h3>
          <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-270">
            <strong className="text-blue-800" data-id="element-271">Indications:</strong>
            <span className="text-blue-700" data-id="element-272">
              {' '}
              Back pain, sciatica, occipital headache, neck stiffness, entire
              back pain, upper back pain, posterior lower limbs
            </span>
          </div>
          <div className="bg-purple-50 p-4 rounded-lg mb-4" data-id="element-273">
            <strong className="text-purple-800" data-id="element-274">Four Magical Meridians:</strong>
            <span className="text-purple-700" data-id="element-275">
              {' '}
              Lung + Spleen + Small Intestine + Bladder (Tai Yin - Tai Yang
              pair)
            </span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-276">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-277">
              <h4 className="font-semibold text-blue-800 mb-3" data-id="element-278">
                LUNG & SPLEEN
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-279">
                {['LU-5 to LU-11', 'SP-1 to SP-9'].map(point => <span key={point} className="px-3 py-1 bg-blue-200 text-blue-800 rounded-full text-sm font-medium" data-id="element-280">
                    {point}
                  </span>)}
              </div>
            </div>
            <div className="bg-red-50 p-4 rounded-lg" data-id="element-281">
              <h4 className="font-semibold text-red-800 mb-3" data-id="element-282">
                SMALL INTESTINE & BLADDER
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-283">
                {['SI-3 to SI-8', 'BL-40 to BL-67'].map(point => <span key={point} className="px-3 py-1 bg-red-200 text-red-800 rounded-full text-sm font-medium" data-id="element-284">
                    {point}
                  </span>)}
              </div>
            </div>
          </div>
          <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 mt-4" data-id="element-285">
            <strong className="text-yellow-800" data-id="element-286">Posterior Treatment:</strong>
            <span className="text-yellow-700" data-id="element-287">
              {' '}
              Most common pattern for back complaints. Needle opposite side.
              Consider layering with Million Dollar Back Combo.
            </span>
          </div>
        </div>
      </div>
      <div className="bg-orange-50 border-l-4 border-orange-500 p-6 mt-8" data-id="element-288">
        <strong className="text-orange-800 text-lg" data-id="element-289">
          Clinical Strategy - Truss Structure Static Balance:
        </strong>
        <ul className="mt-3 space-y-2 text-orange-700" data-id="element-290">
          <li data-id="element-291">• Identify symptom location: Front, Side, or Back</li>
          <li data-id="element-292">• Select corresponding Global Balance pattern</li>
          <li data-id="element-293">
            • Use truss structure: needle the paired meridian, not the affected
            one
          </li>
          <li data-id="element-294">
            • For dynamic balance: needle ALL points on the treatment meridian
          </li>
          <li data-id="element-295">• Combine with seasonal points for enhanced effect</li>
        </ul>
      </div>
    </div>;
}